<template>
  <b-row v-if="items">
    <b-col>
      <b-row>
        <b-col v-if="items.length > 0">
          <table class="table table-sm table-striped table-hover">
            <thead>
            <tr>
              <th>{{$t('views.userdata.show.servicemancars.car')}}</th>
              <th>{{$t('views.userdata.show.servicemancars.dateFrom')}}</th>
              <th>{{$t('views.userdata.show.servicemancars.dateTo')}}</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr
                    v-for="item in items"
                    :key="item['@id']">
              <td>
                {{ item['car'].name }} {{ item['car'].model }} ({{ item['car'].registrationNumber }})
              </td>
              <td>
                {{ item['dateFrom'] }}
              </td>
              <td>
                {{ item['dateTo'] }}
              </td>
              <td>
                <div class="btn-group float-right">
                  <button
                    type="button"
                    class="btn btn-sm btn-link fa fa-edit fa-lg"
                    @click="editAssignation(item)"
                    v-b-tooltip.hover :title="$t('buttons.edit')">
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-link fa fa-trash fa-lg"
                    @click="removeAssignation(item)"
                    v-b-tooltip.hover :title="$t('buttons.delete')">
                  </button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-btn @click="assignCarToServiceman()" variant="success">{{ $t('buttons.assignCar') }}</b-btn>
          <CreateCarUserDataModal></CreateCarUserDataModal>
          <UpdateCarUserDataModal></UpdateCarUserDataModal>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import getId from '@/utils/getIdFromLink'
import CreateCarUserDataModal from '../../../excmcaruserdata/components/CreateCarUserDataModal'
import UpdateCarUserDataModal from '../../../excmcaruserdata/components/UpdateCarUserDataModal'
import { mapActions, mapGetters } from 'vuex'
import ApiService from '@/utils/ApiService'

export default {
  name: 'ServicemanCars',
  components: {
    CreateCarUserDataModal,
    UpdateCarUserDataModal
  },
  props: {
    serviceman: {
      type: Object,
      required: true
    },
    date: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      items: []
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'excmcaruserdata/list/isLoading'
    }),

    assignationCreated () {
      return this.$store.state.modals.userdata.assignCarCreate.created
    },

    assignationUpdated () {
      return this.$store.state.modals.userdata.assignCarUpdate.updated
    }
  },

  watch: {
    assignationCreated: function (val) {
      if (val === 1) {
        this.getUserDataCars()
        this.$store.state.modals.userdata.assignCarCreate.created = 0
      }
    },

    assignationUpdated: function (val) {
      if (val === 1) {
        this.getUserDataCars()
        this.$store.state.modals.userdata.assignCarUpdate.updated = 0
      }
    },

    items: function () {
      for (let i in this.items) {
        if (this.items[i].dateTo) {
          this.items[i].dateTo = this.$moment(this.items[i].dateTo).format('YYYY-MM-DD')
        }
        if (this.items[i].dateFrom) {
          this.items[i].dateFrom = this.$moment(this.items[i].dateFrom).format('YYYY-MM-DD')
        }
      }
    }
  },

  created () {
    this.getUserDataCars()
  },
  methods: {
    ...mapActions({
      delUserDataCars: 'excmcaruserdata/del/del'
    }),
    async getUserDataCars () {
      let params = {
        'dateTo[after]': this.date,
        'dateFrom[before]': this.date
      }
      const response = await new ApiService('user_datas/' + this.getIdLink(this.serviceman['@id']) + '/user_data_cars', params).getResults()
      this.items = response.items
    },
    removeAssignation (assignation) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.delUserDataCars(assignation).then(() => this.getUserDataCars())
        }
      })
    },

    editAssignation (assignation) {
      this.$store.state.modals.userdata.assignCarUpdate.show = 1
      this.$store.state.modals.userdata.assignCarUpdate.serviceman = this.serviceman
      this.$store.state.modals.userdata.assignCarUpdate.assignation = assignation
    },

    assignCarToServiceman () {
      this.$store.state.modals.userdata.assignCarCreate.show = 1
      this.$store.state.modals.userdata.assignCarCreate.serviceman = this.serviceman
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
